import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";
import * as FaIcons from "react-icons/fa";
import R0LearningCenterInformation from "../../components/registrationAdmin/registrationSteps/R0LearningCenterInformation";
import R1SummerSession from "../../components/registrationAdmin/registrationSteps/R1SummerSession";
import R2StudentInformation from "../../components/registrationAdmin/registrationSteps/R2StudentInformation";
import R3ParentInformation from "../../components/registrationAdmin/registrationSteps/R3ParentInformation";
import R4PhysicalAddress from "../../components/registrationAdmin/registrationSteps/R4PhysicalAddress";
import R5MailingAddress from "../../components/registrationAdmin/registrationSteps/R5MailingAddress";
import R6Ethnicity from "../../components/registrationAdmin/registrationSteps/R6Ethnicity";
import R7PreviousSchoolInformation from "../../components/registrationAdmin/registrationSteps/R7PreviousSchoolInformation";
import R8PrimaryLanguage from "../../components/registrationAdmin/registrationSteps/R8PrimaryLanguage";
import R9HomeLanguage from "../../components/registrationAdmin/registrationSteps/R9HomeLanguage";
import R10MigrantEducation from "../../components/registrationAdmin/registrationSteps/R10MigrantEducation";
import R11ReleaseRequests from "../../components/registrationAdmin/registrationSteps/R11ReleaseRequests";
import R12DassInformation from "../../components/registrationAdmin/registrationSteps/R12DassInformation";
import R13HomeSurvey from "../../components/registrationAdmin/registrationSteps/R13HomeSurvey";
import R14HealthConditions from "../../components/registrationAdmin/registrationSteps/R14HealthConditions";
import R15ParentCustodyInformation from "../../components/registrationAdmin/registrationSteps/R15ParentCustodyInformation";
import R16EmergencyContacts from "../../components/registrationAdmin/registrationSteps/R16EmergencyContacts";
import ErrorLogger from "../../components/ErrorLogger";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import llacFav from "../../img/LLAC-favicon.ico";
import { Helmet } from "react-helmet-async";
import SiteZipSearchModal from "../../components/registrationAdmin/SiteZipSearchModal";
import SiteFieldSearchModal from "../../components/registrationAdmin/SiteFieldSearchModal";
import PostRegistrationModal from "../../components/registrationAdmin/PostRegistrationModal";
import StudentMatchModal from "../../components/registrationAdmin/StudentMatchModal";

import checkValidation from "../../functions/checkValidation";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";

const AddRegistrationPage = () => {
  const navigate = useNavigate();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    formData,
    formModal: {
      siteZipSearchModal,
      siteFieldSearchModal,
      studentMatchModal,
      postRegistrationModal,
    },
    setLocationInfo,
    selectEnrollmentType,
    getAge,
    setLanguageToEnglish,
    onFormDataChange,
    setFormModal,
    getSearchSites,
    validationCheck,
    setValidationCheck,
  } = adminRegistrationContext;
    const adminInterestContext = useContext(AdminInterestContext);
    const {updateEnrollmentStatus  } = adminInterestContext;

  const { registerForIntercession } = formData;

  useEffect(() => {
    getSearchSites();
  }, []);

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   checkValidation(formData, setValidationCheck);
    
  //   try {
  //     if (!checkValidation(formData, setValidationCheck)) {
  //       setValidationCheck(false);
  //       setFormModal("postRegistrationModal", true);
  //     }
  //   } catch (error) {
  //     console.error(error.message);
  //     ErrorLogger.logError(error.message);
  //   }
  // };
  const onSubmit = (e) => {
  e.preventDefault();
  checkValidation(formData, setValidationCheck);
  
  try {
    if (!checkValidation(formData, setValidationCheck)) {
      setValidationCheck(false);
      
      // Validate form data before submission
           
        // Include both UUID and learningCenterId in the form data when submitting
        setFormModal({ ...formData, _uuid: formData._uuid });
       
        // Get UUID from formData instead of URL parameters
        const currentUuid = formData._uuid;
        console.log("currentUuid",currentUuid)
        
        // Updating enrollstatus in enrollment collection i.e interest form status
        if (currentUuid) {
          try {
            updateEnrollmentStatus(currentUuid, 'Yes','Enrolled');
            console.log('Enrollment status updated successfully');
          } catch (statusError) {
            console.error('Error updating enrollment status:', statusError);
            // Don't throw here - registration was successful even if status update failed
            ErrorLogger.logError(`Failed to update enrollment status for UUID ${currentUuid}: ${statusError.message}`);
          }
        }
      
      
      setFormModal("postRegistrationModal", true);
    }
  } catch (error) {
    console.error(error.message);
    ErrorLogger.logError(error.message);
  }
};

  return (
    <AdminLayout>
       <Helmet>
        <meta charSet="utf-8" />
        <title>Add Registration Form</title>
         <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      {/* {orientationModal && <OrientationModal type="PRE" />} */}
      {postRegistrationModal && <PostRegistrationModal />}
      {siteFieldSearchModal && (
        <SiteFieldSearchModal setLocationInfo={setLocationInfo} />
      )}
      {siteZipSearchModal && (
        <SiteZipSearchModal setLocationInfo={setLocationInfo} />
      )}
      {studentMatchModal && <StudentMatchModal type="PRE" id="null" />}
      <section id="add-registration">
        <div className="container">
          <div
            className="right display-back"
            style={{ fontSize: "18px" }}
            onClick={() => {
              navigate(-1);
            }}
          >
            <FaIcons.FaArrowAltCircleLeft className="back-icon" />
            <h4>Back</h4>
          </div>

          <h2 className="text-center top-title">Add Registration Form</h2>
          <div className="search-modal-btns">
            <div
              onClick={() => setFormModal("siteZipSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Zip
            </div>
            <div
              onClick={() => setFormModal("siteFieldSearchModal", true)}
              className="btn btn-llac-light-green"
            >
              Search Site by Fields
            </div>
          </div>
          <form onSubmit={onSubmit} className="sub-forms form">
            <R0LearningCenterInformation
              formData={formData}
              validationCheck={validationCheck}
            />
            {/* Enrollment Type */}
            {/* <R1SummerSession
              formData={formData}
              onFormDataChange={onFormDataChange}
              validationCheck={validationCheck}
              selectEnrollmentType={selectEnrollmentType}
            /> */}
            {/* Student Information */}
            <R2StudentInformation
              formData={formData}
              onFormDataChange={onFormDataChange}
              validationCheck={validationCheck}
              getAge={getAge}
            />
            {/* <div className="sub-form">
              <h3>Find Student Match</h3>
              <div
                onClick={() => {
                  setFormModal("studentMatchModal", true);
                  getStudentMatchResults(studentMatchData);
                }}
                className="btn btn-llac-dark-green"
              >
                Find Student Match
              </div>
            </div> */}
            {/* Parent/Guardian Information */}
            <R3ParentInformation
              formData={formData}
              onFormDataChange={onFormDataChange}
              validationCheck={validationCheck}
            />
            {/* Physical Address */}
            <R4PhysicalAddress
              formData={formData}
              onFormDataChange={onFormDataChange}
              validationCheck={validationCheck}
            />
            {/* Mailing Address */}
            <R5MailingAddress
              formData={formData}
              onFormDataChange={onFormDataChange}
              validationCheck={validationCheck}
            />

            {!registerForIntercession && (
              <>
                {/* Ethnicity */}
                <R6Ethnicity
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Previous School/Enrollment Information */}
                <R7PreviousSchoolInformation
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Primary Language */}
                <R8PrimaryLanguage
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Home Language Survey */}
                <R9HomeLanguage
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                  setLanguageToEnglish={setLanguageToEnglish}
                />
                {/* Migrant Education */}
                <R10MigrantEducation
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Release Requests */}
                <R11ReleaseRequests
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Dass Information */}
                <R12DassInformation
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Home Survey */}
                <R13HomeSurvey
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Health Conditions */}
                <R14HealthConditions
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Parent Custody Information */}
                <R15ParentCustodyInformation
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
                {/* Emergency Contacts */}
                <R16EmergencyContacts
                  formData={formData}
                  onFormDataChange={onFormDataChange}
                  validationCheck={validationCheck}
                />
              </>
            )}
            <div className="submit-btn-box">
              {/* <div
                onClick={() => {
                  checkValidation();
                  if (!checkValidation()) {
                    handleCompleteEnrollment();
                    // setFormModal("confirmModal", true);
                  }
                }}
                className="btn btn-llac-dark-green"
              >
                Complete Enrollment
              </div> */}
              <div onClick={onSubmit} className="btn btn-llac-dark-green">
                Submit
              </div>
            </div>
          </form>
        </div>
      </section>
    </AdminLayout>
  );
};

export default AddRegistrationPage;
